import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithdrawalVenmoComponent } from './withdrawal-venmo.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    WithdrawalVenmoComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    WithdrawalVenmoComponent
  ]
})
export class WithdrawalVenmoModule { }
